import axios from "axios";
import {v4 as uuid} from "uuid";
import Utils from "./Utils";


class AthnAuth {
    _idTokenNoAuth = "eyJraWQiOiJvMjdIRGZTVlFoWTFKRnlYTXhvTjJEYWlDNytxbHZvaEJNblpoZlhvSlE0PSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoieEVudElVeDJxbFl3NEdvbndWRW1mUSIsInN1YiI6IjdmMGY2Y2RmLWYxNjItNDhjYi05OTJhLWIxMWZkNjZiZTkwMyIsImN1c3RvbTpjb2RpY2Vfc3RydXR0dXJhIjoibG9jYWwiLCJhcG1zOnJ1b2xvX29yZyI6IiIsImN1c3RvbTpjb2RpY2VfZmlzY2FsZSI6ImZyaWZkbmFzZmVlZmFzYXMiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtY2VudHJhbC0xLmFtYXpvbmF3cy5jb21cL2V1LWNlbnRyYWwtMV9IRktlSk52am4iLCJjb2duaXRvOnVzZXJuYW1lIjoiZnJpZmRuYXNmZWVmYXNhcyIsImdpdmVuX25hbWUiOiJGZXJkaW5hbmRvIiwiYXVkIjoiMTd1ZjM0cHRqczQyMjlhOTc0YjBwYW1xb2ciLCJldmVudF9pZCI6IjBjZDkzYjIxLWFhZGItNDQ5MC1iYjIxLTE4MmZmMjQzZjk3MyIsInRva2VuX3VzZSI6ImlkIiwiYXBtczpzY2FkZW56YV9wd2QiOiJXZWQgRGVjIDAyIDIwMjAgMTE6MTg6MDMgR01UKzAwMDAgKENvb3JkaW5hdGVkIFVuaXZlcnNhbCBUaW1lKSIsImF1dGhfdGltZSI6MTYyMzkxNzYzNSwiYXBtczpncnVwcGkiOiJvcF9yZWciLCJjdXN0b206YXBtczpjb2RpY2VfZmlzY2FsZSI6IkZSSUZETkFTRkVFRkFTQVMiLCJleHAiOjE2MjM5MjEyMzUsImlhdCI6MTYyMzkxNzYzNSwiZmFtaWx5X25hbWUiOiJGaW9yZSIsImVtYWlsIjoiZmVyZGluYW5kby5maW9yZUBkeGMuY29tIn0.RH4k7G0mx2E7lPU-wVGfKlMDFELBsulgkRrR1miittR_yoR4hRIbhbI1nnyNkxhanvB8-SgVEHVGiSaEpEUfoeTVsdVtUtdI-m2xCvtOtJrRusv4JfuBIa5LLF8haBMGWx2DdICekwKfWaess6P-lqngrMFM6dusL4mMDnalvgLEQo0y4707luXf4r4r7B6xBfA94or6e-LPqj4yjGPUwY4gjNpzykbolrTvNFQBLuOovpXkrpcYV0KCBvs0yapF0MQl0BSN3fhT1pDeKAfSqs2hESDTXUxcBpl1ryTGmxIsRBxareZj0-x-BqvK-flvWVP_v42pHhitaZBToU52fQ";
    _samlTokenNoAuth = "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";
    _timeoutRigenerazioneToken = 2700000;
    _timeoutSessionInactivity = 3600000;
    _timeoutSession = 28800000;
    _timeoutRigenerazioneSamlToken = 13500000;
    _idToken = sessionStorage.getItem("idToken") ? sessionStorage.getItem("idToken") : null;
    _testaRefreshToken = sessionStorage.getItem("testaRefreshToken") ? sessionStorage.getItem("testaRefreshToken") : null;
    _sessionId = sessionStorage.getItem("sessionId") ? sessionStorage.getItem("sessionId") : null;
    _samlToken = sessionStorage.getItem("samlToken") ? sessionStorage.getItem("samlToken") : null;
    _httpClient = null;
    sessioneUtente = sessionStorage.getItem("sessioneUtente") ? JSON.parse(sessionStorage.getItem("sessioneUtente")) : null
    utente = this.sessioneUtente &&  this.sessioneUtente.tipoUtente !== "03" ? this.sessioneUtente : {
        nome: "test",
        cognome: "test",
        codiceFiscale: "testtest",
        codiceStruttura: "local",
        gruppi: "RAF-Admin",
        ultimoLogin: new Date()
        // quando verra creata la vera sessione utente aggiornare anche il campo ultimoLogin per utente collegato
    };
    contesto = null;

    constructor() {
        axios.interceptors.request.use(
            request => {
                return this._interceptor(request)
            },
            error => {
                return error
            }
        );

        this._httpClient = axios.create({
            timeout: 10000,
            responseType: 'json'
        });
    }

    _makeid = (length) => {
        var result = ''
        var characters = 'abcdef0123456789'
        var charactersLength = characters.length
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
        }
        return result
    }

    _interceptor(request) {
        if (request.url !== this._urlAthnTokens &&
            request.url !== this._urlAthnRefreshToken &&
            request.url !== this._urlAthnSamlToken) {

            request.headers['AZContext'] = `sessionid=${this._sessionId};applicationid=${this._applicationId};operationid=${this._makeid(16)};contesto=${this.contesto}`;
            if (this._auth) {
                request.headers['Authorization'] = `Bearer ${this._idToken}`;
                //request.headers['AZUser'] = `id=${this.utente.codiceFiscale};name=${this.utente.nome};surname=${this.utente.cognome};authenticationinfo=localtest;roles=${this.utente.gruppi ? this.utente.gruppi : this.utente.ruolo}`;
            } else {
                request.headers['AZUser'] = `id=${this.utente.codiceFiscale};name=${this.utente.nome};surname=${this.utente.cognome};authenticationinfo=localtest;roles=${this.utente.gruppi ? this.utente.gruppi : this.utente.ruolo}`;
            }

            if (this._auth) {
                if (Utils.isEmpty(this.sessioneUtente) || (this.sessioneUtente && this.sessioneUtente.tipoUtente === "03")){
                    if (request.url.includes("/assistenti")) {
                        request.url = request.url.replace("/assistenti", "/public/assistenti")
                    }
                    if (request.url.includes("/toponomastica")) {
                        request.url = request.url.replace("/toponomastica", "/public/toponomastica")
                    }
                    if (request.url.includes("/anagrafica")) {
                        request.url = request.url.replace("/anagrafica", "/public/anagrafica")
                    }
                    if (request.url.includes("/sportelli")) {
                        request.url = request.url.replace("/sportelli", "/public/sportelli")
                    }
                }else if(this.sessioneUtente && this.sessioneUtente.tipoUtente === "02"){
                    if (request.url.includes("/report") && window.location.pathname === "/home") {
                        request.url = request.url.replace("/assistenti", "/public/assistenti")
                    }
                }
            }

            if (this._samlTokenResources.find((item) => {
                return request.url.includes(item);
            })) {
                if (this._auth) {
                    if(this._samlToken){
                        let url = request.url.concat("&authrve1b=" + this._samlToken.toString());
                        request.url = url;
                    }
                } else {
                    let url = request.url.concat("&authrve1b=" + this._samlTokenNoAuth);
                    request.url = url;
                }

            }

            if(this._auth && (this.sessioneUtente && this.sessioneUtente.tipoUtente !== "03")){
                let idToken = this._parseJwt(this._idToken);
                if (Date.now() >= (idToken.exp) * 1000 && this._auth) {
                    this._logout(this);
                }
                //1200s = 20m prima che scada il token
                if (Date.now() >= (idToken.exp - 1200) * 1000 && this._auth) {
                    this._rigenerazioneToken(this);
                }
            }
        }

        return request
    }

    _generazioneCodeVerifier() {
        const randomItems = new Uint32Array(128);
        window.crypto.getRandomValues(randomItems);
        const binaryStringItems = randomItems.map(dec => `0${dec.toString(16).substr(-2)}`)
        return binaryStringItems.reduce((acc, item) => `${acc}${item}`, '');
    }

    async _generazioneCodeChallange(codeVerifier) {
        const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier));
        const stringifiedArrayHash = new Uint8Array(digest).reduce((acc, i) => `${acc}${String.fromCharCode(i)}`, '');
        return btoa(stringifiedArrayHash).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    _parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    async _rigenerazioneToken(instance) {
        if (instance._auth) {
            let res = await instance._httpClient.post(instance._urlAthnRefreshToken, {
                sessioneUtente: {
                    sessionId: instance._sessionId,
                    testaRefreshToken: instance._testaRefreshToken
                }
            }, {withCredentials: true});
            instance._idToken = res.data.idToken;
            instance._testaRefreshToken = res.data.testaRefreshToken;
            sessionStorage.setItem("idToken", res.data.idToken)
            sessionStorage.setItem("testaRefreshToken", res.data.testaRefreshToken)
        } else {
            console.log("Rigenerazione token");
        }
    }

    async _generazioneSamlToken(instance) {
        try {
            if (instance._auth) {
                let res = await instance._httpClient.post(instance._urlAthnSamlToken, {sessionId: instance._sessionId}, {withCredentials: true});
                instance._samlToken = res.data.samlToken;
            } else {
                instance._samlToken = instance._samlTokenNoAuth;
            }
            sessionStorage.setItem("samlToken", instance._samlToken)
            if (!instance._refreshSamlTokenTimeout) {
                instance._refreshSamlTokenTimeout = setInterval(instance._generazioneSamlToken, instance._timeoutRigenerazioneSamlToken, instance);
            }
        } catch (error) {
            this._samlTokenErrorFunction(error.response.data.ErrorCode, error.response.data.Description);
        }
    }

    async _loginCallback() {
        var urlParams = JSON.parse('{"' + decodeURI(window.location.search).substring(1)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') + '"}');

        let currentState = sessionStorage.getItem("state");
        if (currentState === urlParams.state) {
            if (this._auth) {
                let res = await this._httpClient.post(this._urlAthnTokens, {
                    authorizationCode: urlParams.code,
                    codeVerifier: sessionStorage.getItem("code_verifier")
                }, {withCredentials: true});
                this._idToken = res.data.idToken;
                this._testaRefreshToken = res.data.testaRefreshToken;
                this._sessionId = res.data.sessionId;
            } else {
                this._idToken = this._idTokenNoAuth;
                this._sessionId = uuid();
            }
            sessionStorage.setItem("idToken", this._idToken)
            sessionStorage.setItem("testaRefreshToken", this._testaRefreshToken)
            sessionStorage.setItem("sessionId", this._sessionId)
            let idToken = this._parseJwt(this._idToken);
            this.utente.nome = idToken.given_name;
            this.utente.cognome = idToken.family_name;
            if(idToken["custom:codice_fiscale"] && idToken["custom:codice_fiscale"].includes("TINIT-")){
                this.utente.codiceFiscale = idToken["custom:codice_fiscale"].replace("TINIT-","");
            }else{
                this.utente.codiceFiscale = idToken["custom:codice_fiscale"];
            }
            this.utente.codiceStruttura = idToken["custom:codice_struttura"];
            this.utente.gruppi = idToken["apms:gruppi"];
            this.utente.sportelli = idToken["apms:RAF-ente"];
            this.utente.ultimoLogin = new Date()
            if (!this.utente.gruppi) {
                this.utente.gruppi = "RAF-AF"
            }
            this._refreshTimeout = setInterval(this._rigenerazioneToken, this._timeoutRigenerazioneToken, this);
            this._sessionInactivityTimeout = setTimeout(this._logout, this._timeoutSessionInactivity, this);
            this._sessionTimeout = setTimeout(this._logout, this._timeoutSession, this);

            //riabilitare la chiamata per la generazione del saml token appena si renderà necessario utilizzare un servizio infrastrutturale (esempio A2 o FSER)
            this._generazioneSamlToken(this);

            this._loggedin = true;
        }
        return this.utente;
    }

    configurazione(config) {
        this._auth = config.auth;
        this._applicationId = config.applicationId;
        this._urlAthn = config.urlAthn;
        this._samlTokenErrorFunction = config.samlTokenErrorFunction;
        this._samlTokenResources = config.samlTokenResources;
        this._urlAthnLogin = `${this._urlAthn}/athn/login`;
        this._urlAthnLogout = `${this._urlAthn}/athn/logout`;
        this._urlAthnTokens = `${this._urlAthn}/athn/tokens`;
        this._urlAthnRefreshToken = `${this._urlAthn}/athn/refreshtoken`;
        this._urlAthnSamlToken = `${this._urlAthn}/athn/samltoken`;
    }

    async login() {
        let state = uuid();
        sessionStorage.setItem("state", state);
        let codeVerifier = this._generazioneCodeVerifier();
        sessionStorage.setItem("code_verifier", codeVerifier);
        let codeChallenge = await this._generazioneCodeChallange(codeVerifier);
        if (this._auth) {
            window.location.href = `${this._urlAthnLogin}?state=${state}&codeChallenge=${codeChallenge}`;
        } else {
            window.location.href = `login-callback?state=${state}`;
        }
    }

    async recuperoSessione(samlTokenErrorCallback) {
        if (window.location.pathname === "/login-callback") {
            return this._loginCallback(samlTokenErrorCallback);
        } else if (window.location.pathname === "/logout-callback") {
            window.location.href = "/home";
        } else if (window.location.pathname === "/logout") {
            this.logout()
        }
    }

    _logout(instance) {
        console.log(`auth: ${instance._auth}`);
        console.log(`auth: ${instance._idToken}`);
        sessionStorage.removeItem("state");
        sessionStorage.removeItem("code_verifier");
        clearInterval(instance._refreshTimeout);
        clearInterval(instance._refreshSamlTokenTimeout);
        clearTimeout(instance._sessionTimeout);
        clearTimeout(instance._sessionInactivityTimeout);
        instance._idToken = null;
        instance._samlToken = null;
        instance._testaRefreshToken = null;
        instance._sessionId = null;
        instance._loggedin = false;
        sessionStorage.setItem("sessioneUtente",JSON.stringify({tipoUtente: "03",loggedIn:false}))
        sessionStorage.removeItem("idToken")
        sessionStorage.removeItem("samlToken")
        sessionStorage.removeItem("sessionId")
        sessionStorage.removeItem("testaRefreshToken")
        if (instance._auth) {
            window.location.href = `${instance._urlAthnLogout}`
        } else {
            window.location.href = "/home";
        }
    }

    logout() {
        this._logout(this);
    }

    setSessioneUtente(sessioneUtente) {
        this.sessioneUtente = sessioneUtente
    }
}

const auth = new AthnAuth();

export default auth;